import React, { useContext, useEffect, useState } from "react";
import { Breadcrumb, SimpleCard } from "@gull";
import { Formik } from "formik";
import { Helmet } from "react-helmet";
import DatePicker from "react-datepicker";

import { model, validationModel, StatusList } from "./addMerchantModel";
import {
  RenderSelectInput,
  RenderTextInput,
  RenderTextArea,
  RenderDateInput,
} from "app/common/renderInput";

import { getMerchant, addMember } from "app/services/memberService";
import queryString from "app/services/queryStringService";
import { getUserGroup } from "app/services/userGroupService";

import { NotificationManager } from "react-notifications";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { AppContext } from "app/appContext";
import moment from "moment";

function AddMerchant() {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  const [userGroupDetails, setUserGroupDetails] = useState(null);

  const [state, setState] = useState({
    model,
    merchants: [],
    chosenAdhaarFile: "",
    chosenPanFile: "",
  });

  const pageMount = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: 1,
      pageSize: 50,
    });

    const response = await getMerchant(query);
    const data = response.data.data;
    const merchantsList = data.map((x, i) => {
      return {
        value: x.memId,
        label: x.memberFullName,
      };
    });
    setState({ merchants: [...merchantsList] });
  };

  useEffect(() => {
    pageMount();
    const userHandler = async () => {
      const userDetails = await getUserGroup();
      setUserGroupDetails(
        userDetails.data.data.map((item) => {
          return { value: item.id, label: item.name };
        })
      );
    };
    userHandler();
  }, []);

  const handleSubmit = async (values, { setSubmitting }) => {
    setShow(true);
    const res = await addMember(values);
    // console.log(res);
    try {
      if (res.status == "Success") {
        navigate("/admin/merchants");
        NotificationManager.success(res.message);
        setShow(false);
      } else {
        NotificationManager.error(res.message);
        setShow(false);
      }
    } catch (error) {
      NotificationManager.error(error);
      setShow(false);
    }
  };
  const context = useContext(AppContext);
  return (
    <div>
      <Helmet>
        <title>Add Vendor</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[
          { name: "API Vendor List", path: "/admin/api-list" },
          { name: "Add Vendor" },
        ]}
      ></Breadcrumb>
      <div>
        <Formik
          initialValues={state.model}
          validationSchema={validationModel}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            isValid,
            dirty,
            setFieldValue,
          }) => {
            return (
              <form
                className="needs-validation"
                onSubmit={handleSubmit}
                noValidate
              >
                {/* <div>
                        <div className="col-md-12">
                          {Object.values(errors).map(msg => (
                            <>
                              {msg}
                              <br />
                            </>
                          ))}
                        </div>
                      </div> */}
                <div className="row">
                  <div className="col-12">
                    <SimpleCard className="mb-4">
                      <div className="row">
                        <RenderTextInput
                          type="text"
                          name="vendorName"
                          display="API Vendor Name"
                          placeholder="API Vendor Name"
                          value={values.vendorName}
                          error={errors.vendorName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.vendorName}
                          required
                        ></RenderTextInput>

                        <RenderTextInput
                          type="text"
                          name="vendorShortCode"
                          display="API Vendor Code"
                          placeholder="API Vendor Code"
                          value={values.vendorShortCode}
                          error={errors.vendorShortCode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.vendorShortCode}
                          required
                        ></RenderTextInput>
                      </div>
                      <div className="row">
                        <RenderDateInput
                          type="date"
                          name="regDate"
                          display="API Reg. Date"
                          placeholder="API Reg. Date"
                          value={
                            values.regDate
                              ? new moment(values.regDate).format("YYYY-MM-DD")
                              : ""
                          }
                          error={errors.regDate}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.regDate}
                          required
                        ></RenderDateInput>

                        <RenderSelectInput
                          type="number"
                          name="status"
                          display="Status"
                          value={values.status}
                          error={errors.status}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.status}
                          items={StatusList}
                          required
                        ></RenderSelectInput>
                      </div>
                      <div className="row">
                        <RenderTextArea
                          type="text"
                          name="desc"
                          display="API Desc"
                          placeholder="API Desc"
                          value={values.desc}
                          error={errors.desc}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.desc}
                          required
                        ></RenderTextArea>
                      </div>
                    </SimpleCard>
                  </div>
                </div>

                <Button
                  variant="primary"
                  // className="btn pull-right btn-primary mb-3"
                  type="submit"
                >
                  Add Vendor
                </Button>
              </form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
}

export default AddMerchant;
